
import { useState, useContext } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { useStore, Provider as ReduxProvider, useDispatch } from 'react-redux';
import { IonFabButton, IonIcon, IonSpinner } from '@ionic/react';
import { download } from 'ionicons/icons';

import { downloadLogsReport } from 'actions/ProjectActions';
import { ProjectContext } from 'components/layouts/Project';
import LogsReport from './LogsReport';

export default function LogsDownloadButton({BtnComponent=IonFabButton, text="", iconSlot=""}) {
  const store = useStore();
  const project = useContext(ProjectContext);
  const dispatch = useDispatch();
  const [downloading, setDownloading] = useState(false);

  const downloadReport = async () => {
    if (!store.getState().online) {
      return alert("You must be online to download a report.");
    }
    setDownloading(true);

    const markup = renderToStaticMarkup(
      <ReduxProvider store={store}><LogsReport project={project}/></ReduxProvider>
    );
    try {
      const {url} = await dispatch(downloadLogsReport({id: project.id, markup}));
      window.location.href = url;
    } catch (e) {
      alert(e.message);
    }
    setDownloading(false);
  }

  return (
    <BtnComponent onClick={downloadReport} iconLeft button detail={false}>
      {downloading ? (
        <IonSpinner name="lines-sharp-small" slot={iconSlot}/>
      ) : (
        <IonIcon icon={download} slot={iconSlot}/>
      )}
      {text}
    </BtnComponent>
  )
}

